import React, { Component ,useState, useRef } from "react";
import ReactDOM, {render} from "react-dom";
import moment from 'moment'
import {
  DetailsOfTask,
  ListTask,
  AddEditTask,
  AllTaskCalenderForReports,
  UnlockRequest
} from "../index";
//import 'moment/locale/zh-cn';
import Scheduler, {
  SchedulerData,
  ViewTypes,
  // DATE_FORMAT,
} from "react-big-scheduler";
// import { DemoData } from "../../../pages/test/DemoData";
import withDragDropContext from "../../../withDnDContext";
import { connect } from "react-redux";
import { Calendar, momentLocalizer } from "react-big-calendar";
// import moment from "moment";
import "react-big-scheduler/lib/css/style.css";
import { Overlay, Tooltip,  Row, Col } from "react-bootstrap";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Button } from "reactstrap";
import api from "../../../apis/api";
import "../../../style/calendarclassForReport.css";
import { blue, red } from "@material-ui/core/colors";

const localizer = momentLocalizer(moment);
let dayPropGetter=[];
const IconStyle = {
  cursor: "pointer"
};
let taskc=[];
let holidaylist=[];
let schedulerData = new SchedulerData(
  new Date(),
  ViewTypes.Week,
  false,
  false,
  {
    // minuteStep: 15
  }
);

const TooltipContent = ({onClose, event}) => {
  return (
    <React.Fragment>
      <FontAwesomeIcon
        icon={faWindowClose}
        className="pull-right"
        style={IconStyle}
        onClick={onClose}
      />
      <div>Project - {event.event.projectName}</div>
      <div>{event.title}</div>
      <div>Description - {event.event.description}</div>
      <div>Hours Billable -{event.event.HoursBillable}</div>
      <div>Hours Spent -{event.event.Hoursspent}</div>
      <div>Status -{event.event.status}</div>
    </React.Fragment>
  );
}

class Basic extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    const events = [
      {
        id: 0,
        title: "All Day Event",
        allDay: true,
        start: now,
        end: now
      }
    ];
    this.state = {
      name: "React",
      events
    };

    // let schedulerData = new SchedulerData(
    //   new moment("2017-12-18").format(DATE_FORMAT),
    //   ViewTypes.Week
    // );
    // let schedulerData = new SchedulerData(
    //   new Date(),
    //   ViewTypes.Week,
    //   false,
    //   false,
    //   {
    //     // minuteStep: 15
    //   }
    // );

    // schedulerData.localeMoment.locale("en");

    // schedulerData.setResources(DemoData.resources);

    // schedulerData.setEvents(DemoData.events);
    this.state = {
      //   viewModel: schedulerData,
      calendarShedularData: {},
      calendarShedularData1: {}
    
    };
    
  }

  componentDidUpdate(prevProps) {
    const { fullTaskArr } = this.props.fullTaskArr;
    // const handelIsprojectOrEmployee = this.props.handelIsprojectOrEmployee;
    if (prevProps.fullTaskArr.fullTaskArr.length !== fullTaskArr.length) {
      this.dataPopulationReactScheduler(fullTaskArr);
    }
  }

  componentDidMount() {
    const { fullTaskArr, empTask } = this.props.fullTaskArr;
    // let taskList = empTask.filter((el) => el.status === "inProgress");
  
    this.dataPopulationReactScheduler(this.props.selectedTask);
    // this.apicalling();
  }

  // func to handle data population in react-big-schedular, for componentDidMout & componentDidUpdate.
  dataPopulationReactScheduler = (fullTaskArr) => {
   
    // get the unique name.
    // let resources = this.getProjectNames(fullTaskArr);
    // let events = this.getEvents(fullTaskArr);
    // const calendarData = { resources: resources, events: events };
    // // const [recholidayCalendarArray,setrecholidayCalendarArray] = useState([]);
    // let recholidayCalendarArray=[];  
    // // console.log(calendarData);
    // schedulerData.setResources(calendarData.resources);
    // schedulerData.setEvents(calendarData.events);  
    // schedulerData.config.schedulerWidth = "80%";
    // this.setState({
    //   calendarShedularData: schedulerData,
    //   calendarData: calendarData,
    //   calendarShedularData1 :fullTaskArr
    // });
    // const fetchApi = async () => {
    //   await api.dbcalendar().GetRecHolidayCalendarList().then((res) => recholidayCalendarArray.push(res.data));
    // }
    // fetchApi(); 

  };
// apicalling =() =>{
//   // let recholidayCalendarArray=[];
//   const fetchApi = async () => {
//     await api.dbcalendar().GetRecHolidayCalendarList().then((res) => this.state.recholidayCalendarArray.push(res.data));
//   }
//   fetchApi(); 
// }
  // get project name, no repeatations.
  getProjectNames = (fullTaskArr) => {
    let projectNameArr = Array.from(
fullTaskArr
    ).map((id) => {

      return {
        id: id.employeeId,
        name: id.employeeName,
      };
    });
 
    return projectNameArr;
    // return [];
  };
  eventStyleGetter= function(event) {

    var backgroundColor = '#' + event.hexColor;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: 'black',
        border: '0px',
        display: 'block'
    };
    return {
        style: style
    };
};
  //   to make the events for the calender.
  
  getEvents = (fullTaskArr) => {
    let taskColor = ["#FA9E95", "#6a7d15", "#6a7d15", "#a6120d"];
    taskc=[];
    const maplist=[];
    const unique=[];
    holidaylist=[];
    this.props.fullTaskArr.recandholidayList.map(function (hol){
      holidaylist.push(hol);
    })


    if(this.props.handelIsprojectOrEmployee =='1')
    {
      const mapped = fullTaskArr.map((obj, index) =>maplist.push({value:obj.employeeID,label:obj.employeeName}));
      const filtered= maplist.filter((v,i,a)=>a.findIndex(v2=>(v.value===v2.value))===i);
   // const filtered = maplist.filter((type, index) =>  maplist.indexOf(type.value) === index  )
   filtered.map((els) => {
     taskc.push({value:els.value,project:els.label,label:"#"+(Math.random().toString(16).substr(-6))});
   }); 
   let allEvents1 = holidaylist.map((el,i) => {
    return {
      id: i+1,
      start: moment(el.holidayDate).format('YYYY-MM-DD') + " 09:30:00",
      end: moment(el.holidayDate).format('YYYY-MM-DD')+ " 13:30:00",
      resourceId:1,
      projectName:"test",
      label :"1111",
      title: el.title ,
      status:"Completed",
      Hoursspent:12,
      HoursBillable:12,
      hexColor:"#FF0000",
      description : "test"
    };
    
  });
       let allEvents = fullTaskArr.map((el) => {
         let colu=[];
         const start = el.startTime.split(" ");
         const end = el.endTime.split(" ");
        //  let bb=new Date(el.startTime) ;
   let ffp=taskc.map((v,l) => (v.value == el.employeeID ? colu.push(taskc[l].label)  : null));
         return {
           id: el.employeeTimeSheetId,
           start: moment(el.workDate).format('YYYY-MM-DD') +" " + start[1],
           end: moment(el.workDate).format('YYYY-MM-DD') +" " + end[1],
           resourceId: el.employeeID,
           projectName:el.projectName,
           label :"1111",
           title: el.issueTitle ,
           status:(el.timeSheetStatus==1 ? "New" : (el.timeSheetStatus == 2 ? "In Progress" : "Completed")),
           Hoursspent:el.hoursSpent,
           HoursBillable:el.hoursBillable,
           hexColor:colu[0],
           description : el.description
           //   showPopover: false,
         };
       });
       const arr3 = [...allEvents, ...allEvents1];
       return arr3;
    }
    else{
      const mapped = fullTaskArr.map((obj, index) =>maplist.push({value:obj.employeeId,label:obj.employeeName}));
      const filtered= maplist.filter((v,i,a)=>a.findIndex(v2=>(v.value===v2.value))===i);
      let allEvents2 = holidaylist.map((el,i) => {
        return {
          id: i+1,
          start: moment(el).format('YYYY-MM-DD') + " 09:30:00",
          end: moment(el).format('YYYY-MM-DD') + " 13:30:00",
          resourceId:1,
          projectName:"test",
          label :"1111",
          title: "Holiday" ,
          status:"Completed",
          Hoursspent:12,
          HoursBillable:12,
          hexColor:"#FF0000",
          description : "test"
        };
        
      });
   // const filtered = maplist.filter((type, index) =>  maplist.indexOf(type.value) === index  )
   filtered.map((els) => {
     taskc.push({value:els.value,project:els.label,label:"#"+(Math.random().toString(16).substr(-6))});
   }); 
   let allEvents =[];
       fullTaskArr.map((el,k) => {
         let colu=[];
         allEvents = el.dailyStatuses.map((el1,i) =>{
    return {
      id: i+1,
      start: moment(el1.dates).format('YYYY-MM-DD') ,
      end: moment(el1.dates).format('YYYY-MM-DD'),
      resourceId:1,
      projectName:"LLL",
      label :(el1.status)+"(8:00)\n(8:00)",
      title: (el1.status)+"(8:00)\n(8:00)",
      status:(el1.status),
      Hoursspent:9,
      HoursBillable:8,
      bgColor : "red !important",
      description : ""
      //   showPopover: false,
    };
   })
  
   unique.push({id: k+1,
    start: moment(new Date()).format('YYYY-MM-DD') ,
    end: moment(new Date()).format('YYYY-MM-DD'),
    resourceId:el.employeeId,
    projectName:el.employeeName,
    label : el.workFromHomeCount,
    title: el.departmentName == null ? "" : el.departmentName,
    status:el.leaveCount,
    Hoursspent:9,
    HoursBillable:8,
    hexColor : "red !important", 
    description : allEvents
    }); 
    
       });
       return unique;
    }
   
   
  }

  render() {
    const { calendarShedularData } = this.state; 
    const { calendarShedularData1 } = this.state;
    const { handleToggleAllTaskCalendar } = this.props; 
    const { taskdata } = this.props.selectedTask; 
    const getDaysInMonth = (month, year) => {
      return new Array(31)
        .fill(null)
        .map((_, index) => new Date(year, month, index + 1))
        .filter((date) => date.getMonth() === month);
    };
  
    // Get current month and year
    const currentMonth = new Date('2024-12-01').getMonth();
    const currentYear = new Date('2024-12-01').getFullYear();
  
    const days = getDaysInMonth(currentMonth, currentYear);

      const { currentPage, employeesPerPage } = this.state; // ⭐ NEW CODE
    const indexOfLastEmployee = currentPage * employeesPerPage; // ⭐ NEW CODE
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage; // ⭐ NEW CODE
    
    // const {holidaycal}=this.props.holidaycal;
    // const [recholidayCalendarArray, setrecholidayCalendarArray] = useState([]);
    // let holidaylist=[];
    // holidaycal.map(function (hol){
    //   holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
    // })
    const currentYear1 = new Date().getFullYear();
    const currentMonth1 = new Date().getMonth(); // Ensure correct month
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); // Get correct days count
    
    const days1 = Array.from({ length: daysInMonth }, (_, i) => new Date(currentYear, currentMonth, i + 1));
    
    return (
      <div>
       <div><br/></div> 

  <div
  style={{
    maxHeight: this.props.disablePagination ? "auto !important" : "80vh",
    overflowY: this.props.disablePagination ? "visible !important" : "auto",
    overflowX: "hidden",
    paddingRight: "8px",
    width: "100%"
  }}
>
  {this.props.selectedTask.map((employee) => (
    <div className="calendar-container">
      <div className="calendar-header">
        <div>Employee ID: {employee.employeeId}</div>
        <div>Name: {employee.employeeName}</div>
        <div>Department: {employee.departmentName}</div>
      </div>

      <div className="calendar-grid">
      {days.map((day) => {
    const dayData = employee.dailyStatuses.find(
      (d) => new Date(d.dates).getDate() === day.getDate()
    );
const cleanStatus = dayData?.status
  ? dayData.status
      .replace(/\([^)]*\)/g, '')     // remove text inside ()
      .replace(/\bMiscarriage\b/gi, 'LMC') // ✅ map Miscarriage → LMC
      .replace(/\bPaternity\b/gi, 'PTL') // ✅ map Paternity → LMC
      .replace(/\s*\+\s*/g, ' + ')
      .replace(/\s+/g, ' ')
      .trim()
  : dayData?.status;


    return (
    <div
  className="calendar-cell"
  key={day}
  style={{
    background:
      cleanStatus == "Not Applied" || cleanStatus == null
        ? "lightblue"
        : cleanStatus == "AC"
        ? "lightyellow"
        : cleanStatus == "Holiday"
        ? "lightcoral"
        : (cleanStatus == "WFH" ||
           cleanStatus == "AO" ||
           cleanStatus == "WFO" || 
           cleanStatus == "WFH + WFO" || cleanStatus == "WFO + WFH" ||
           cleanStatus == "AO + WFO" || cleanStatus == "WFO + AO" ||
           cleanStatus == "WFH + AO" || cleanStatus == "AO + WFH" ||
           cleanStatus == "WFH + AC" || cleanStatus == "AC + WFH" ||
           cleanStatus == "WFO + AC" || cleanStatus == "AC + WFO" ||
           cleanStatus == "WFH + LOP"|| cleanStatus == "LOP + WFH" ||
           cleanStatus == "WFO + LOP"|| cleanStatus == "LOP + WFO"
          )
        ? ((dayData?.dutyStatusId == 1 || dayData?.dutyStatusId ==0)? "yellow" : "lightgreen")
        : "lightpink",
  }}
>

        <div className="date">{day.getDate()}</div>
     <div className={`status ${cleanStatus}`}>
  {dayData ? (
    dayData.isAuto
      ? dayData.status.replace(/LOP/g, "Auto LOP")
      : dayData.status
  ) : (
    ""
  )}
</div>

      </div>
    );
  })}

      </div>
      <div className="calendar-summary">
        Absent: {employee.leaveCount} Present: {employee.workFromHomeCount}
      </div>
    </div>
  ))}
</div>



       
        {/* {viewModel !== null ? (
          <Scheduler
            schedulerData={viewModel}
            prevClick={this.prevClick}
            nextClick={this.nextClick}
            onSelectDate={this.onSelectDate}
            onViewChange={this.onViewChange}
            eventItemClick={this.eventClicked}
            viewEventClick={this.ops1}
            viewEventText="Ops 1"
            viewEvent2Text="Ops 2"
            viewEvent2Click={this.ops2}
            updateEventStart={this.updateEventStart}
            updateEventEnd={this.updateEventEnd}
            moveEvent={this.moveEvent}
            newEvent={this.newEvent}
          />
        ) : null} */}
      </div>
    );
  }
  

  prevClick = (schedulerData) => {
    schedulerData.prev();
    schedulerData.setEvents(this.state.calendarData.events);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };

  nextClick = (schedulerData) => {
    schedulerData.next();
    schedulerData.setEvents(this.state.calendarData.events);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };

  onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective
    );
    schedulerData.setEvents(this.state.calendarData.events);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };

  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    schedulerData.setEvents(this.state.calendarData.events);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };

  eventClicked = (schedulerData, event) => {
    alert(
      `You just clicked an event: {id: ${event.id}, title: ${event.title}}`
    );
  };

  ops1 = (schedulerData, event) => {
    
  //   <AddEditTask
  //   handleEditTaskForm={this.props.handleAddEditTaskForm}
  //   handleAddUpdateTask={this.props.handleAddUpdateTask}
  //   handleClsAddEditTaskForm={this.props.handleClsAddEditTaskForm}
  //   selectedTask={this.props.selectedTask}
  //   taskProjectInfo={this.props.taskProjectInfo}
  //   addOrEdit={this.props.addOrEdit.current}
  //   getAllTaskOfEmployee={this.props.getAllTaskOfEmployee}
  //   setIsOpenAddEditForm = {this.props.setIsOpenAddEditForm}
  //   unlockReqList = {this.props.unlockReqList}
  // ></AddEditTask>
   alert(
      `You just executed ops1 to event: {id: ${event.id}, title: ${event.title}}`
    );
  };

  ops2 = (schedulerData, event) => {
    alert(
      `You just executed ops2 to event: {id: ${event.id}, title: ${event.title}}`
    );
  };

  newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
    let newFreshId = 0;
    schedulerData.events.forEach((item) => {
      if (item.id >= newFreshId) newFreshId = item.id + 1;
    });

    let newEvent = {
      id: newFreshId,
      title: "New event you just created",
      start: start,
      end: end,
      resourceId: slotId,
      bgColor: "purple",
    };
    schedulerData.addEvent(newEvent);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };

  updateEventStart = (schedulerData, event, newStart) => {
    schedulerData.updateEventStart(event, newStart);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };

  updateEventEnd = (schedulerData, event, newEnd) => {
    schedulerData.updateEventEnd(event, newEnd);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };

  moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
    schedulerData.moveEvent(event, slotId, slotName, start, end);
    this.setState({
      calendarShedularData: schedulerData,
    });
  };
}

const mapStateToProps = (state) => ({
  fullTaskArr: state.taskReducer,
});

export default connect(mapStateToProps, {})(withDragDropContext(Basic));
